"use client";
import React, { useMemo } from "react";
import { NextAero, PreviousAero } from "@/utlility/icons";
import { Pagination } from "react-bootstrap";

const CustomPagination = ({
  currentPage,
  totalRecords,
  limit,
  onPageChange,
  className = "",
}) => {
  const totalPages = Math.max(0, Math.ceil((totalRecords || 0) / (limit || 1)));

  const isFirst = currentPage === 0;
  const isLast = currentPage === totalPages - 1;

  const handlePrevious = () => {
    if (!isFirst) onPageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (!isLast) onPageChange(currentPage + 1);
  };

  const pageNumbers = useMemo(() => {
    if (totalPages <= 1) return [];

    const pages = [];
    const addPage = (i) => pages.push({ type: "page", index: i });
    const addEllipsis = (key) => pages.push({ type: "ellipsis", key });

    addPage(0);

    if (currentPage > 3) addEllipsis("start");

    const rangeStart = currentPage > 3 ? currentPage - 1 : 1;
    const rangeEnd = currentPage < totalPages - 4 ? currentPage + 1 : totalPages - 2;

    for (let i = rangeStart; i <= rangeEnd; i++) {
      addPage(i);
    }

    if (currentPage < totalPages - 4) addEllipsis("end");

    addPage(totalPages - 1);

    return pages;
  }, [currentPage, totalPages]);

  if (totalPages <= 1) return null;

  return (
    <Pagination className={className}>
      {/* Previous Button */}
      <li>
        <button
          onClick={handlePrevious}
          disabled={isFirst}
          className={`page-item ${isFirst ? "disabled" : ""}`}
          aria-label="Previous page"
        >
          <PreviousAero />
        </button>
      </li>

      {/* Page Numbers */}
      <div className="d-flex numbers">
        {pageNumbers.map((item) =>
          item.type === "ellipsis" ? (
            <li key={item.key}>
              <button className="page-item" disabled>…</button>
            </li>
          ) : (
            <li key={item.index}>
              <button
                onClick={() => onPageChange(item.index)}
                className={`page-item ${currentPage === item.index ? "active" : ""}`}
                aria-label={`Page ${item.index + 1}`}
                aria-current={currentPage === item.index ? "page" : undefined}
              >
                {item.index + 1}
              </button>
            </li>
          )
        )}
      </div>

      {/* Next Button */}
      <li>
        <button
          onClick={handleNext}
          disabled={isLast}
          className={`page-item ${isLast ? "disabled" : ""}`}
          aria-label="Next page"
        >
          <NextAero />
        </button>
      </li>
    </Pagination>
  );
};

export default CustomPagination;